import React, { ReactElement, useState, createContext } from 'react';
import classNames from 'classnames/bind';
import { CountryItem } from 'sections/Resources/FreightForwarder/data';
import { SearchPanel } from 'sections/Resources/FreightForwarder/components/SearchPanel';
import { Countries } from 'sections/Resources/FreightForwarder/components/Countries';
import styles from 'sections/Resources/FreightForwarder/components/SectionCountries/SectionCountries.module.scss';

const cn = classNames.bind(styles);

export const CountriesContext = createContext<any>({});

const SectionCountries = (): ReactElement => {
  const [foundTerms, setFoundTerms] = useState<CountryItem[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [isSearchActive, setIsSearchActive] = useState<boolean>(false);

  const contextValue = {
    foundTerms,
    setFoundTerms,
    searchValue,
    setSearchValue,
    isSearchActive,
    setIsSearchActive,
  };

  return (
    <section className={cn('countries')}>
      <div className={cn('container')}>
        <h2 className={cn('countries__heading')}>Find Freight Forwarders by Country</h2>
        <CountriesContext.Provider value={contextValue}>
          <SearchPanel />
          <Countries />
        </CountriesContext.Provider>
      </div>
    </section>
  );
};

export default SectionCountries;
